import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Paper,
  Typography,
} from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { setOpenAllProductsDialog } from "src/features/checkout/checkoutSlice"
import AllProductsDialog from "./AllProductsDialog"
import ActiveProductDialog from "./ActiveProductDialog"
import { useEffect } from "react"
import { useLazyGetProductsByIDsQuery } from "src/features/checkout/storefrontApi"
import { AddonItem } from "./AddonItem"

export default function Addons() {
  const dispatch = useDispatch()
  const addons = useSelector((state) => state.checkout.config.addons)
  const [getProductsByIds, { data, isLoading }] = useLazyGetProductsByIDsQuery()

  useEffect(() => {
    if (addons.length) {
      getProductsByIds(
        addons.map((item) => `${item.product_id}`),
        true,
      )
    }
  }, [addons])

  if (!addons.length) {
    return <></>
  }

  return (
    <>
      <Typography component="h2" variant="h5" mb={2} alignItems="center">
        UPGRADE your order with one of these great options
      </Typography>
      <Grid container spacing={2} mb={2} p={(2, 0)}>
        {isLoading && (
          <Grid item xs={12}>
            <Box component={Paper} sx={{ textAlign: "center" }} p={4}>
              <CircularProgress />
              <br />
              Loading addons...
            </Box>
          </Grid>
        )}

        {data?.nodes
          ?.filter(Boolean) // Remove inactive/draft products.
          .map((addon) => (
            <Grid item key={addon.id} xs={6} sm={4} md={3} lg={3}>
              <AddonItem addon={addon} />
            </Grid>
          ))}

        <Grid item xs={12} sm={4} md={3}>
          <Card
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Box
              height="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              py={2}
            >
              <Button
                onClick={() => {
                  dispatch(setOpenAllProductsDialog(true))
                }}
                color="primary"
              >
                View All Products
              </Button>
            </Box>
          </Card>
        </Grid>
      </Grid>
      <AllProductsDialog />
      <ActiveProductDialog />
    </>
  )
}
